<template>
  <main-layout>
    <v-content>
      <v-container v-if="client">
        <v-card tile>
          <section-header :client.sync="client" />
          <client-steps :client.sync="client" />
          <!-- <v-divider></v-divider> -->
          <client-details :client.sync="client" />
          <client-application v-if=infra.data.gitlabProjects 
            :client.sync=client
            :gitlabProjects.sync=infra.data.gitlabProjects 
            :parsedTags.sync=infra.data.parsedTags
          />
        </v-card>

        <v-divider></v-divider>

        <!-- infra -->
        <v-card tile>
          <v-progress-circular
            v-if="infra.loading === true"
            indeterminate
            color="primary"
          ></v-progress-circular>

          <client-instance
            v-if="infra.data.length"
            :client.sync="client"
            :infra.sync="infra.data"
            class="mt-5"
          />

          <v-alert
            v-else-if="infra.errored.status"
            text
            outlined
            color="red lighten-2"
            icon="mdi-fire"
            dark
          >
            Infrastructure API call failure.
            <br />
            {{ infra.errored.message }}
          </v-alert>
        </v-card>
        <!-- end infra -->

        <!-- registers -->
        <div>
          <client-registers
            v-if="client.registers.length"
            :client.sync="client"
            class="mt-5"
          />
          <v-alert v-else text outlined color="info lighten-2" type="info" dark>
            No registers loaded.
          </v-alert>
        </div>
        <!-- end registers -->

      </v-container>
    </v-content>
  </main-layout>
</template>
<script>
import ClientApplication from "./sections/application";
import ClientDetails from "./sections/details";
import ClientInstance from "./sections/instance";
import ClientRegisters from "./sections/registers";
import ClientSteps from "./sections/steps";
import SectionHeader from "./sections/header";
export default {
  components: {
    ClientApplication,
    ClientDetails,
    ClientInstance,
    ClientRegisters,
    ClientSteps,
    SectionHeader,
  },

  props: {
    id: {
      required: true,
    },
  },
  data: () => ({
    client: null,
    infra: {
      type: null,
      data: [],
      loading: true,
      errored: {
        status: false,
        message: "",
      },      
    },
  }),
  methods: {
    makeClientCall() {
      this.$http.get(`api/v1/clients/${this.id}`).then((client) => {
        this.client = client
      })
      .catch((error) => {
        this.client.errored = {
            status: true,
            message: error,
          };
      })
    },
    makeInfraCall(type) {
      this.infra.type = type
      this.$http
        .get(`api/v1/infra/${type}/${this.id}`)
        .then((infra) => {
          this.infra.data = infra;
          this.infra.loading = false;
        })
        .catch((error) => {
          this.infra.errored = {
            status: true,
            message: error,
          };
          this.infra.loading = false;
        });
    }
  },
  mounted() {
    this.$http.get(`api/v1/clients/${this.id}`).then((client) => {
      this.client = client;
      if(this.client.kubernetes && this.client.kubernetes.namespace) {
        // this.makeInfraCall('kubernetes')
        this.infra.loading = false
        this.infra.errored = {
          message: "Kubernetes feature not enabled.",
          status: true
        }
      } else {
        this.makeInfraCall('aws')
      }
    });
  },
};
</script>
